import React, { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import StripePaymentForm from './StripePaymentForm';
import { useLocation, useSearchParams } from 'react-router-dom';
import Service from '../Dashboard/services/Service';
import './Payment.scss';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const PaymentPage = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [medicationRequestId, setMedicationRequestId] = useState(null);
  const [medicationData, setMedicationData] = useState(null);
  const [loading, setLoading] = useState(false);
  const amount = 49.0;

  const elementsOptions = {
    mode: 'payment',
    amount: (medicationData?.amount || medicationData?.price || amount) * 100,
    currency: 'usd',
    appearance: {
      theme: 'stripe',
    },
  };

  useEffect(() => {
    const requestId = searchParams.get('medicationRequestId') || location.state?.medicationRequestId || sessionStorage.getItem('medicationRequestId');

    if (requestId) {
      setMedicationRequestId(requestId);
      sessionStorage.setItem('medicationRequestId', requestId);
    }

    fetchMedicationData();
  }, [searchParams, location.state]);

  const fetchMedicationData = async () => {
    try {
      setLoading(true);
      const response = await Service.getPatientOffering();
      setMedicationData(response.data);
    } catch (error) {
      console.error('Error fetching offering data:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="shopify-checkout-container">
      <div className="checkout-header">
        <div className="container">
          <h1 className="checkout-logo">SwimScore</h1>
          <div className="checkout-steps">
            <span className="step completed">Cart</span>
            <span className="step-separator">›</span>
            <span className="step active">Payment</span>
          </div>
        </div>
      </div>

      <div className="checkout-content">
        <div className="container">
          <div className="checkout-grid">
            {/* Left Column - Payment Form */}
            <div className="checkout-main">
              <Elements stripe={stripePromise} options={elementsOptions}>
                <StripePaymentForm amount={medicationData?.amount || medicationData?.price || amount} medicationRequestId={medicationRequestId} />
              </Elements>
            </div>

            {/* Right Column - Order Summary */}
            <div className="checkout-sidebar">
              <div className="order-summary">
                <h2>Order Summary</h2>

                <div className="order-item">
                  <div className="item-image">
                    <div className="placeholder-image">💊</div>
                  </div>
                  <div className="item-details">
                    <h3>
                      {loading
                        ? 'Loading...'
                        : medicationData?.offering_title || medicationData?.title || medicationData?.medication_name || 'Targeted Supplements'}
                    </h3>
                    <p>{medicationData?.description || 'Optimize your reproductive health'}</p>
                    <span className="item-quantity">Qty: {medicationData?.quantity || 1}</span>
                  </div>
                  <div className="item-price">${medicationData?.amount?.toFixed(2) || medicationData?.price?.toFixed(2) || amount.toFixed(2)}</div>
                </div>

                <div className="order-totals">
                  <div className="total-line">
                    <span>Subtotal</span>
                    <span>${medicationData?.amount?.toFixed(2) || medicationData?.price?.toFixed(2) || amount.toFixed(2)}</span>
                  </div>
                  <div className="total-line">
                    <span>Shipping</span>
                    <span>Free</span>
                  </div>
                  <div className="total-line total-final">
                    <span>Total</span>
                    <span>${medicationData?.amount?.toFixed(2) || medicationData?.price?.toFixed(2) || amount.toFixed(2)}</span>
                  </div>
                </div>

                <div className="security-badges">
                  <div className="badge">🔒 Secure Checkout</div>
                  <div className="badge">💳 256-bit SSL</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentPage;
